import { useEffect, useState } from 'react';

import { AssetDetails } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { Channel } from '@rikstv/play-common/src/forces/channels/channel.types';

import { routerPaths } from '../../../common/router/router.path';
import { getNavigationUrlAndRecommendedProducts } from '../../packages/utils/getRecommendedProduct';
import { persistShopperAssetOnSignup } from '../../packages/utils/persistShopperAssetOnSignup';

export const usePlayerSignupDialog = (assetOrChannel: AssetDetails | Channel) => {
  const [recommendedProductsUrl, setRecommendedProductsUrl] = useState<string>(routerPaths.signUpPackageSelect);

  useEffect(() => {
    getNavigationUrlAndRecommendedProducts({
      channelExternalIds: [assetOrChannel.originChannel.channelId],
    }).then(recommendation => {
      persistShopperAssetOnSignup(assetOrChannel, recommendation.recommendedProducts?.packageId);
      setRecommendedProductsUrl(recommendation.cmsUrl ?? recommendation.url);
    });
  }, [assetOrChannel]);

  const buttonText = 'Bli kunde';

  return { recommendedProductsUrl, buttonText };
};
